import { StepCard } from './StepCard';
import { ChatMessageDisplayConfig } from '../hooks/useConfigureChatMessageDisplay';
import { ChatMessageDisplayType } from '@scale/shared/types/chat';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Switch } from '@scale/scaleui';
import { useChatLayoutStore } from '../hooks/useChatLayoutStore';

type ChatMessageDisplayConfigProps = {
  useMarkdownDisplay: boolean;
  chatMessageDisplayConfig: ChatMessageDisplayConfig;
  updateMarkdownConfig: (config: Partial<ChatMessageDisplayConfig['markdownConfig']>) => void;
  toggleChatMessageDisplayType: () => void;
  icon?: IconProp;
};

export const ChatMessageDisplayConfigButton = ({
  useMarkdownDisplay,
  chatMessageDisplayConfig,
  updateMarkdownConfig,
  toggleChatMessageDisplayType,
  icon,
}: ChatMessageDisplayConfigProps) => {
  const isDrawerOpen = useChatLayoutStore(state => state.isDrawerOpen);

  return (
    <StepCard.Popover
      useStepCardReference
      icon={icon ?? 'ellipsis'}
      placement={isDrawerOpen ? 'top-end' : 'right-start'}
      modifiers={[
        {
          name: 'preventOverflow',
          options: {
            mainAxis: false,
          },
        },
        {
          name: 'offset',
          options: {
            offset: [0, 14],
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top-end'],
          },
        },
      ]}
    >
      <StepCard>
        <StepCard.Body>
          <div className="flex justify-end" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
            <div className="flex flex-col gap-2">
              <Switch
                size="small"
                label="Render as Markdown"
                checked={chatMessageDisplayConfig.displayType === ChatMessageDisplayType.Markdown}
                onCheckedChange={toggleChatMessageDisplayType}
                altDescription="Render the text in Markdown"
                helperText="Render the text in Markdown"
              />
              <div className="flex items-center">
                <Switch
                  size="small"
                  disabled={!useMarkdownDisplay}
                  label="Render LaTeX"
                  checked={chatMessageDisplayConfig.markdownConfig.enableMathPlugin}
                  onCheckedChange={checked => updateMarkdownConfig({ enableMathPlugin: checked })}
                  altDescription="Render standard LaTeX formatted text"
                  helperText="Render standard LaTeX formatted text"
                />
              </div>
              <div className="flex items-center">
                <Switch
                  size="small"
                  disabled={
                    !useMarkdownDisplay || !chatMessageDisplayConfig.markdownConfig.enableMathPlugin
                  }
                  label="Render Single $ LaTeX"
                  checked={chatMessageDisplayConfig.markdownConfig.enableSingleDollarTextMath}
                  onCheckedChange={checked =>
                    updateMarkdownConfig({ enableSingleDollarTextMath: checked })
                  }
                  altDescription="Render LaTeX using single dollar signs ($)"
                  helperText="Render LaTeX using single dollar signs ($)"
                />
              </div>
            </div>
          </div>
        </StepCard.Body>
      </StepCard>
    </StepCard.Popover>
  );
};
